import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const SocialLinksThunk = createAsyncThunk(
	"SocialLinks/SocialLinksThunk",
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get(
				`https://api.raj.com.sa/api/public/social_links`
			);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data?.data);
		}
	}
);
